import React from "react";
import intl from "react-intl-universal";

import {InTextLabel} from "../../components/InTextLabel/InTextLabel";
import {AuditAssignment} from "../../../stores/audit/types";

/** Single source of truth for how an assignment status renders - shared by the
 *  Assignments table (AuditAssignmentDS) and the Edit assignment modal, so the
 *  two can't drift into showing different labels/colors for the same status.
 *
 *  `audience` only affects the "assigned" label: to an admin it reports a past
 *  action ("Assigned" - I handed this off), but to the auditor who owns the
 *  work it needs to read as a to-do ("Not started"), not a completed step. */
export function AuditAssignmentStatusBadge({status, size = "sm", audience = "admin"}: {status: AuditAssignment['status']; size?: "sm" | "md" | "lg"; audience?: "admin" | "auditor"}) {
    switch (status) {
        case 'completed':
            return <InTextLabel type="success" size={size} text={intl.get('audits.assignments.completed').d('Completed')}/>;
        case 'in_progress':
            return <InTextLabel type="info" size={size} text={intl.get('audits.assignments.inProgress').d('In progress')}/>;
        case 'cancelled':
            return <InTextLabel type="neutral" size={size} text={intl.get('audits.assignments.cancelled').d('Cancelled')}/>;
        case 'assigned':
        default:
            return <InTextLabel
                type="warning"
                size={size}
                text={audience === 'auditor'
                    ? intl.get('audits.assignments.notStarted').d('Not started')
                    : intl.get('audits.assignments.assigned').d('Assigned')}
            />;
    }
}

export function auditAssignmentStatusText(status: AuditAssignment['status']): string {
    switch (status) {
        case 'completed': return intl.get('audits.assignments.completed').d('Completed');
        case 'in_progress': return intl.get('audits.assignments.inProgress').d('In progress');
        case 'cancelled': return intl.get('audits.assignments.cancelled').d('Cancelled');
        case 'assigned':
        default: return intl.get('audits.assignments.assigned').d('Assigned');
    }
}
